import React from "react";

// interfaces
import { IContentPreviewCarousel } from "../../../../interfaces/media/IContentPreviewCarousel";

// components
import ContentCarouselControls from "../contentCarousel/ContentCarouselControls";
import ProgressiveLoadingImage from "../../images/ProgressiveLoadingImage";
import ContentCarouselTimeBelt from "../contentCarousel/ContentCarouselTimeBelt";
import { motion } from "framer-motion";

// hooks
import UseContentCarousel from "./ContentCarousel.hooks";


const ContentCarousel = ({className, mediaItems, token, videoAutoPlayEnabled}: IContentPreviewCarousel) => {
    const hasMedia = Array.isArray(mediaItems) && mediaItems.length > 0;
    if (!hasMedia) {return null}
    
    const {containerRef, counter, getVideoUrl, loadedVideoUrls, setVideoRef, isPaused, onPlayClick, onNavigateClick, FADE_DURATION, SLIDE_DURATION} = UseContentCarousel({mediaItems, token, videoAutoPlayEnabled});


    return (
        <div ref={containerRef} className={`content-preview-carousel ${className ?? ""}`}>
            <div className="carousel-frame">
                {mediaItems.map((item, index) => {
                    const isActive = index === counter;
                    const videoUrl = item.mediaType === "video" && item.url
                            ? getVideoUrl(item.url)
                            : null;
                    const shouldLoadVideo = videoUrl !== null && loadedVideoUrls.has(videoUrl);

                    return (
                        <motion.div
                            key={`${item.url ?? index}-${index}`}
                            className={`slide ${item.mediaType === "video" ? "is-video" : "is-image"}`}
                            initial={false}
                            animate={{opacity: isActive ? 1 : 0}}
                            transition={{duration:FADE_DURATION, ease: "easeInOut"}}
                            style={{
                                position: "absolute",
                                inset: 0,
                                zIndex: isActive ? 2 : 1,
                                pointerEvents: isActive ? "auto" : "none"
                            }}
                            aria-hidden={!isActive}
                        >

                            {(item.mediaType === "image" || item.mediaType === "audio") && item.url && (
                                <ProgressiveLoadingImage
                                    imageUrl={item.url}
                                    maxWidth={600}
                                    token={token}
                                />
                            )}


                            {/* 
                             * Every video element stays mounted and we just add src once the video becomes
                             * current or next.
                            */}
                            {item.mediaType ==="video" && item.url && (
                                <video
                                    ref={video => setVideoRef(index, video)}
                                    muted
                                    playsInline
                                    preload={isActive ? "auto" : "metadata"}
                                    disablePictureInPicture
                                    aria-label=""
                                    src={shouldLoadVideo ? videoUrl ?? undefined : undefined}
                                    />
                            )}
                        </motion.div>
                    )}
                )}
            </div>

            <ContentCarouselTimeBelt
                key={counter}
                uniqueId={counter}
                animationDuration={SLIDE_DURATION / 1000}
                isPaused={isPaused}
            />
        
            <ContentCarouselControls
                currentItem={counter}
                totalItems={mediaItems.length}
                isPaused={isPaused}
                onPlayButtonClick={onPlayClick}
                onLeftClick={() => onNavigateClick("previous")}
                onRightClick={() => onNavigateClick("next")}
            />
        </div>
    );
};


export default ContentCarousel;